import HubPage from '../../components/HubPage';
export default function FinanceHub() { return <HubPage hubKey="finance" />; }
